import type { DbTagRow } from '../types.js';
import { scopeDepthInChain } from './scope-utils.js';
import type { NavigationSource } from './types.js';

export function isConfidentNavigation(
  definitions: readonly DbTagRow[],
  source: NavigationSource,
  primary: DbTagRow | null,
): boolean {
  if (definitions.length === 1) return true;
  if (definitions.length === 0) return false;

  if (source === 'import') return false;

  if (primary == null) return false;

  const sorted = sortDefinitionsForDisplay(primary, primary.file_path, definitions);
  const top = sorted[0];
  const second = sorted[1];
  if (!top || !second) return false;

  const topDepth = scopeDepthInChain(top, primary);
  const secondDepth = scopeDepthInChain(second, primary);
  if (topDepth < secondDepth) return true;

  return false;
}

export function sortDefinitionsForDisplay(
  ref: DbTagRow,
  refFile: string,
  definitions: readonly DbTagRow[],
): DbTagRow[] {
  return [...definitions].sort((a, b) => {
    const depthDiff = scopeDepthInChain(a, ref) - scopeDepthInChain(b, ref);
    if (depthDiff !== 0) return depthDiff;

    const fileDiff = (a.file_path === refFile ? 0 : 1) - (b.file_path === refFile ? 0 : 1);
    if (fileDiff !== 0) return fileDiff;

    if (a.start_line !== b.start_line) return a.start_line - b.start_line;
    return a.start_column - b.start_column;
  });
}
